module.exports = __webpack_public_path__ + "img/AccessibleForwardOutlined.304ed6ca.svg";